import { createAsyncThunk } from '@reduxjs/toolkit'
import { setOwners } from '../owners/ownerSlice'
import axios from 'axios'
import { replaceOwnerThreads } from './messageThreadSlice'
import { setMessages } from '../messages/messageSlice'
import { setUsers } from '../users/userSlice'

const typePrefix = 'app/createThread'

export const createThread = createAsyncThunk(
  typePrefix,
  async ({ message, unique_owner_id, participants }, { dispatch, rejectWithValue, getState }) => {
    try {
      const response = await axios.post('/api/messaging/create_thread', {
        message, unique_owner_id, participants
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })

      const state = getState()
      const data = response?.data

      dispatch(replaceOwnerThreads({ threads: data.message_threads, owner_id: unique_owner_id }))
      dispatch(setMessages(data.messages))
      dispatch(setOwners(data.owners))
      dispatch(setUsers(data.users))

      return data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
